import { useLocale } from "../i18n/useLocale.js";
import { useCompactViewport } from "../promo/useCompactViewport";

export function formatSavedAt(date, localeTag = "nl-NL") {
  return new Intl.DateTimeFormat(localeTag, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function formatSavedAtCompact(date, localeTag = "nl-NL") {
  return new Intl.DateTimeFormat(localeTag, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function SaveIndicator({ savedAt }) {
  const { display } = useLocale();
  const { isCompact } = useCompactViewport();
  const formatted = formatSavedAt(savedAt, display.localeTag);
  const formattedCompact = formatSavedAtCompact(savedAt, display.localeTag);
  const statusLabel = display.t("web.save.autoSavedStatus", { time: formatted });

  return (
    <div
      className={`header-save-status${isCompact ? " header-save-status--compact" : ""}`}
      role="status"
      aria-live="polite"
      aria-label={isCompact ? statusLabel : undefined}
    >
      <span className="header-save-status-icon" aria-hidden="true">
        ✓
      </span>
      <span className="header-save-status-copy" aria-hidden={isCompact ? true : undefined}>
        {display.t("web.save.autoSavedPrefix")}{" "}
        <time dateTime={savedAt.toISOString()}>{formatted}</time>
      </span>
      {isCompact ? (
        <time
          className="header-save-status-compact-time"
          dateTime={savedAt.toISOString()}
          aria-hidden="true"
        >
          {formattedCompact}
        </time>
      ) : null}
    </div>
  );
}
